import { apiClient } from './client';

export interface ChatbotMessage {
  role: 'user' | 'assistant';
  content: string;
  timestamp?: string;
}

export interface ChatbotRequest {
  message: string;
  history?: ChatbotMessage[];
}

export interface ChatbotResponse {
  message: string;
  actionExecuted: boolean;
  actionData?: any;
  timestamp: string;
}

export interface TenantInfo {
  slug: string;
  name: string;
}

export const chatbotService = {
  async sendMessage(
    message: string,
    history: ChatbotMessage[] = [],
  ): Promise<ChatbotResponse> {
    const response = await apiClient.post<ChatbotResponse>(
      '/chatbot/message',
      {
        message,
        history: history.map((msg) => ({
          role: msg.role,
          content: msg.content,
        })),
      },
    );

    return response as unknown as ChatbotResponse;
  },

  async getTenantInfo(): Promise<TenantInfo> {
    const response = await apiClient.get<TenantInfo>('/chatbot/tenant-info');
    return response as unknown as TenantInfo;
  },
};